<template lang="pug">
v-alert(type="info", prominent)
  v-row(align="center")
    v-col.grow
      div <b>Important Notice:</b>
      div This site is no longer receiving updates as of June 2025. Please access the <b>New Back Office</b> for the latest features.
    v-col.shrink
      v-btn(@click="goNow", color="secondary", small) Go Now
</template>

<script>
export default {
  props: {
    customPath: { type: String, default: "" },
  },
  methods: {
    goNow() {
      if (this.customPath) {
        const url = `https://www.selflane.com/admin/${this.customPath}`;
        window.open(url, "_blank");
        return;
      }
      // get the current url
      const fullPath = this.$route.fullPath;
      // 1. partner paths
      if (fullPath.startsWith("/partner")) {
        let path;
        if (fullPath == "/partner/dev/issues") {
          path = "/crm/dev-issues";
        } else if (fullPath.startsWith("/partner/crm")) {
          // replace /partner/crm with /crm
          path = fullPath.replace("/partner/crm", "/crm");
        } else {
          path = fullPath.replace("/partner", "/crm");
        }
        window.open(`https://www.selflane.com/${path}`, "_blank");
        return;
      }
      // 2. admin paths
      const url = `https://www.selflane.com/admin/${fullPath}`;
      window.open(url, "_blank");
    },
  },
};
</script>